export const HISTORY_TYPES = {
  maintenance_log: 'Maintenance log',
  completed_work_order: 'Completed work order',
  completed_request: 'Completed request',
};

const REQUEST_OUTCOME_LABELS = {
  work_order: 'Work Order Created',
  maintenance_log: 'Maintenance Log Created',
  follow_up: 'Follow-up Created',
  no_action: 'Acknowledged – No Action',
};
export const requestOutcomeLabel = (event) => REQUEST_OUTCOME_LABELS[event?.request_outcome] || null;
export const historyTypeLabel = (event) => (event.event_type === 'completed_request' && requestOutcomeLabel(event))
  || HISTORY_TYPES[event.event_type] || event.event_type;

export const firstLine = (value) => String(value || '').split(/\r?\n/).map((line) => line.trim()).find(Boolean) || '';
export const workHeadline = (event) => event.event_type === 'completed_work_order'
  ? firstLine(event.title) || firstLine(event.description) || 'Work order'
  : firstLine(event.description) || firstLine(event.title) || HISTORY_TYPES[event.event_type];

export const laborValue = (value) => {
  if (value == null || value === '' || typeof value === 'boolean') return null;
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : null;
};
export const formatLabor = (value) => laborValue(value) == null ? '—'
  : new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(Number(value));

export const followUpState = (event) => {
  const followUps = event.follow_ups || [];
  if (followUps.some((f) => f.status === 'open')) return 'open';
  if (followUps.length && followUps.every((f) => f.status === 'resolved')) return 'resolved';
  return followUps.length ? 'unknown' : 'none';
};

export const periodSummary = (events) => ({
  workOrders: events.filter((e) => e.event_type === 'completed_work_order').length,
  logs: events.filter((e) => e.event_type === 'maintenance_log').length,
  requests: events.filter((e) => e.event_type === 'completed_request').length,
  equipment: new Set(events.map((e) => e.machinery_id).filter(Boolean)).size,
  labor: events.reduce((sum, e) => sum + (laborValue(e.hours_spent) ?? 0), 0),
  withLabor: events.filter((e) => laborValue(e.hours_spent) != null).length,
});